import { SET_DROPDOWN_MENU_ITEMS_LIST } from "../actions/types";

const initialState = {
    sapPlant: [],
    sapStorageLocation: [],
    operationTeam: [],
    vehicleType: [],
    tank: [],
    status: [],
    sapMaterial: [],
    unit: [],
    yesNo: [],
    sourceDestination: [],
    location: [],
    plantGroup: [],
    materialGroup: [],
    salesOrg: [],
    bagLq: [],
    shipmentType: [],
    sapVendorMatser: [],
    position: [],
    sapCustomers: []
};
const DropdownMenuItemsReducer =  (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case SET_DROPDOWN_MENU_ITEMS_LIST:
            return { ...state, ...payload };
        default:
            return state;
    }
}

export default DropdownMenuItemsReducer;